import endpoints from '@app/src/api/endpoints'
import { FetchKey, useFetchResource } from '@app/src/api/fetchHooks'
import { useAccount } from '@app/src/context/AccountContext'
import type { OrganizationAssessmentSettings } from '@app/src/types/resourceExplorer'
import { AssessmentType } from '@app/src/types/resourceExplorer'
import { keepPreviousData } from '@tanstack/react-query'
import { useFlags } from 'launchdarkly-react-client-sdk'
import { useMemo } from 'react'

export const useFetchAssessmentSettings = () => {
  const { account } = useAccount()
  const { assessments } = useFlags()

  const {
    data: assessmentSettings = [],
    isLoading,
    isError,
  } = useFetchResource<OrganizationAssessmentSettings[]>({
    key: FetchKey.OrganizationAssessmentSettings,
    endpoint: endpoints.organizationAssessmentSettings,
    options: {
      enabled: Boolean(account?.organization),
      placeholderData: keepPreviousData,
    },
  })

  const filteredAssessmentSettings = useMemo(() => {
    return assessmentSettings.filter(setting => {
      const { assessmentType } = setting.assessmentTemplate

      if (assessmentType === AssessmentType.BaselineAssessment) {
        return true
      }

      if (assessmentType === AssessmentType.StandardAssessment || assessmentType === AssessmentType.Flexible) {
        return assessments
      }

      return false
    })
  }, [assessmentSettings, assessments])

  return {
    assessmentSettings: filteredAssessmentSettings,
    isLoading,
    isError,
  }
}
